<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_xix">The Secret of Apollo</a><a id="page_xx"></a></p><a id="page_xx">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// other.vue?6ba6b7bb